import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNotPrivate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M7.25 13a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M9.699 1.946a3.65 3.65 0 0 0-3.65 3.65v2.433A3.5 3.5 0 0 0 3 11.5v2.75a3.5 3.5 0 0 0 3.5 3.5H13a3.5 3.5 0 0 0 3.5-3.5V11.5A3.5 3.5 0 0 0 13 8H7.549V5.596a2.15 2.15 0 0 1 2.15-2.15h.643a2.12 2.12 0 0 1 2.121 2.121.75.75 0 0 0 1.5 0c0-2-1.62-3.621-3.621-3.621zM4.5 11.5a2 2 0 0 1 2-2H13a2 2 0 0 1 2 2v2.75a2 2 0 0 1-2 2H6.5a2 2 0 0 1-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotPrivate;
